export default __webpack_public_path__ + "static/media/ChristmasBanner2023Desktop1.059d2b76.png";